import $ from 'jquery';

$(document).ready( function($) {

  /**
   * Check user is still logged in
   */
  $('body').hasClass('logged-in') &&
  setInterval(function () {
    $.ajax({
      data: {
        action: 'bs_is_logged_in',
      }
    });
  }, 30000);


  $(document).ready(function ($) {
    $('#periodSelect').on('change', function () {
      popupManager.loading();
      location.href = $(this).val();
    });
  });


  /**
   * Account settings from handler
   */
  /*
  formManager.initForm('form.edit-account', {
    rules: {
      account_first_name: {
        required: true,
      },
      account_last_name: {
        required: true,
      },
      account_display_name: {
        required: true,
      },
      account_email: {
        required: true,
      },
      password_current: {
        required: function() {
          return ( Boolean( $('form.edit-account').find('input[name="password_1"]').val() ) || Boolean( $('form.edit-account').find('input[name="password_2"]').val() ) )
        },
      },
      password_1: {
        required: function() {
          return Boolean( $('form.edit-account').find('input[name="password_current"]').val() )
        },
        minlength: 8,
        pwcheck: true,
      },
      password_2: {
        equalTo: 'form.edit-account input[name="password_1"]'
      }
    }
  });
   */
});